<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-alert :value="error" type="error" transition="scale-transition">{{errorMessage}}</v-alert>

    <v-card>
      <v-card-title>
        <span class="headline">التسجيل</span>
      </v-card-title>
      <v-card-text>
        نحتاج معلومات أساسية لنوصلك مع المساعدين -نوعدك ماراح نزعجك-
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field
                label="الاسم"
                v-model="fullname"
                v-validate="'required'"
                :error-messages="errors.collect('fullname')"
                name="fullname"
                data-vv-as="fullname"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                label="البريد الإلكتروني"
                v-model="email"
                v-validate="'required|email'"
                :error-messages="errors.collect('email')"
                name="email"
                data-vv-as="email"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                label="كلمة المرور"
                v-model="password"
                v-validate="'required'"
                :error-messages="errors.collect('password')"
                name="password"
                :type="'password'"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click="dialog = false">إلغاء</v-btn>
        <v-btn :disabled="!valid" color="success" @click="submit">التسجيل</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    value: Boolean
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  data() {
    return {
      email: null,
      password: "",
      fullname: null,
      valid: true,
      error: false,
      errorMessage: "حدث خطأ نرجو المحاولة مرة أخرى",
      body: "",
      bodyRules: [
        v => !!v || "النص مطلوب",
        v => (v && v.length <= 500) || "النص يجب أن يكون أقل من 500"
      ]
    };
  },
  methods: {
    ...mapActions(["login", "register"]),
    async submit() {
      var valid = await this.$validator.validateAll();
      if (valid) {
        let _this = this;
        try {
          await this.register({
            fullname: this.fullname,
            email: this.email,
            password: this.password
          });

          this.email = null;
          this.password = null;
          this.dialog = false;
        } catch (err) {
          this.errorMessage = err.message;
          this.error = true;
        }
      }
    }
  }
};
</script>

<style scoped>
</style>
